import type { RefObject } from 'react';
import { useEffect, useRef, useState } from 'react';

import { useIsLaptop } from 'hooks/device/useIsLaptop';
import { useIsMobileApp } from 'hooks/useIsMobileApp';
import { useIsPWA } from 'hooks/useIsPWA';

export const useBottomBarScroll = (
  navigationRef: RefObject<HTMLElement | null>
) => {
  const isPwa = useIsPWA();
  const isLaptopAndAbove = useIsLaptop();
  const scrollRef = useRef({ oldScroll: 0 });
  const { isMobileApp } = useIsMobileApp();

  const [hideBottomBar, setHideBottomBar] = useState(false);

  useEffect(() => {
    if (isLaptopAndAbove || isPwa) {
      return () => {};
    }

    const onScroll = () => {
      const { scrollingElement } = document;
      if (!scrollingElement || !navigationRef.current || isMobileApp) {
        return;
      }

      const { scrollTop } = scrollingElement;
      const isScrollingDown = scrollRef.current.oldScroll < scrollTop;
      const hasReachedTop = scrollTop <= 0;

      scrollRef.current.oldScroll = scrollTop;
      setHideBottomBar(isScrollingDown && !hasReachedTop);
    };

    window.document.addEventListener('scroll', onScroll);
    return () => {
      window.document.removeEventListener('scroll', onScroll);
    };
  }, [isMobileApp, isPwa, navigationRef, isLaptopAndAbove]);

  return hideBottomBar;
};
